import InfoIconWithTooltip from './InfoIconWithTooltip';

export * from './types';
export default InfoIconWithTooltip;
